module.exports = __webpack_public_path__ + "img/jdm3.f6ccb812.jpg";